import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "mb-2 ml-2" };
const _hoisted_2 = { class: "fw-bold" };
const _hoisted_3 = { class: "mb-4 data-box__select" };
const _hoisted_4 = { class: "item" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { style: { "display": "flex", "flex-direction": "row" } };
const _hoisted_7 = {
    key: 0,
    style: { "flex": "1 1 auto" },
    class: "text-end"
};
const _hoisted_8 = { class: "text-muted" };
const _hoisted_9 = {
    key: 0,
    class: "item-secondary"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "col-md-3" };
const _hoisted_13 = { class: "col-md-3" };
const _hoisted_14 = { class: "col-md-6" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_select_field = _resolveComponent("g-select-field");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$tc('client.Commerce.Carts.InvoiceAddress')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.invoicing, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                name: "invoicing",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.addresses.invoice.mode) = $event)),
                                value: item.name
                            }, null, 8, _hoisted_5), [
                                [_vModelRadio, _ctx.data.addresses.invoice.mode]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", null, _toDisplayString(item.caption), 1),
                            (item.name === _ctx.data?.addresses?.invoice?.mode || !item.hideIfNotSelected)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("span", _hoisted_8, [
                                        _createVNode(_component_g_dynamic_html, {
                                            template: item.description,
                                            templateProps: { item: item }
                                        }, null, 8, ["template", "templateProps"])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (_ctx.data?.addresses?.invoice?.mode === item.name && item.detailsMode === 'address')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _hoisted_10,
                            _createElementVNode("div", null, [
                                _createElementVNode("div", null, [
                                    _createVNode(_component_g_text_field, {
                                        label: "Name 1",
                                        "data-member": "addresses.invoice.name1",
                                        "validation-rules": { required: true }
                                    })
                                ]),
                                _createElementVNode("div", null, [
                                    _createVNode(_component_g_text_field, {
                                        label: "Name 2",
                                        "data-member": "addresses.invoice.name2"
                                    })
                                ]),
                                _createElementVNode("div", null, [
                                    _createVNode(_component_g_text_field, {
                                        label: "Zusatz",
                                        "data-member": "addresses.invoice.addition"
                                    })
                                ]),
                                _createElementVNode("div", null, [
                                    _createVNode(_component_g_text_field, {
                                        label: "Straße",
                                        "data-member": "addresses.invoice.street",
                                        "validation-rules": { required: true }
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_g_select_field, {
                                            label: "Land",
                                            "data-member": "addresses.invoice.country",
                                            "item-source": _ctx.schema.dataSources.countries_invoice,
                                            "value-expr": "name",
                                            "display-expr": "caption"
                                        }, null, 8, ["item-source"])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createVNode(_component_g_text_field, {
                                            label: "Plz",
                                            "data-member": "addresses.invoice.zipCode",
                                            "data-object": _ctx.data,
                                            "validation-rules": { required: true }
                                        }, null, 8, ["data-object"])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createVNode(_component_g_text_field, {
                                            label: "Ort",
                                            "data-member": "addresses.invoice.city",
                                            "validation-rules": { required: true }
                                        })
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 64));
            }), 256))
        ])
    ], 64));
}
